import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { HttpService } from '../../services/http/http.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { tap, switchMap, catchError } from 'rxjs/operators';
import { EMPTY} from 'rxjs';

enum RifiutoStep {
  PROFILO = 1,
  COMPETENZE = 2,
}

@Component({
  selector: 'app-rifiuta-profilo',
  templateUrl: './rifiuta-profilo.component.html',
  styleUrls: ['./rifiuta-profilo.component.scss'],
  imports: [MatDialogModule, MatIconModule, MatButtonModule],
  standalone: true,
})
export class RifiutaProfiloComponent {
  constructor(
    public dialogRef: MatDialogRef<RifiutaProfiloComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { idProposta: number },
    public api: HttpService,
    public snackBar: MatSnackBar,
  ) {}

  step: RifiutoStep = RifiutoStep.PROFILO;
  get title(): string {
    return this.step === RifiutoStep.PROFILO
      ? 'Rifiuta profilo'
      : 'Rifiuta competenze associate';
  }

  get message(): string {
    return this.step === RifiutoStep.PROFILO
      ? 'Sei sicuro di voler rifiutare il profilo?'
      : 'Si deve procedere al rifiuto anche delle competenze e relative Abilità e Conoscenze associate al profilo rifiutato?';
  }

  handleClick(): void {
    this.step === RifiutoStep.PROFILO
      ? this.handleProfiloStep()
      : this.handleCompetenzeStep();
  }

  private handleProfiloStep(): void {
    this.api
      .profileHasDraftCompetences({ valore: this.data.idProposta })
      .pipe(
        switchMap((res: any) => {
          if (!res.result.booleano) {
            return this.rifiutaProfilo$().pipe(
              tap(() => {
                this.snackBar.open('Profilo rifiutato', 'close', {
                  panelClass: 'successSnack',
                });
                this.dialogRef.close(true);
              }),
            );
          } else {
            this.step = RifiutoStep.COMPETENZE;
            return EMPTY;
          }
        }),
        catchError((error) => {
          console.error('Errore controllo competenze:', error);
          this.snackBar.open(
            'Errore durante il controllo delle competenze',
            'close',
            {
              panelClass: 'errorSnack',
            },
          );
          return EMPTY;
        }),
      )
      .subscribe();
  }

private handleCompetenzeStep(): void {
  this.rifiutaProfilo$()
    .pipe(
      switchMap((response: any) =>
        response.operation === 2
          ? this.api.rifiutaCompetenzeByIdProfilo(this.data.idProposta)
          : EMPTY
      ),
      tap((res: any) => {
        if (res) {
          this.snackBar.open(res.messaggio, 'close', {
            panelClass: 'successSnack',
          });
          this.dialogRef.close(true);
        }
      }),
      catchError((error) => {
        console.error('Errore rifiuto competenze:', error);
        this.snackBar.open(
          'Errore durante il rifiuto delle competenze',
          'close',
          { panelClass: 'errorSnack' }
        );
        return EMPTY;
      })
    )
    .subscribe();
}


  private rifiutaProfilo$() {
    return this.api.rifiutaProfilo({ valore: this.data.idProposta });
  }

private rifiutaProfiloDiretto(): void {
    this.rifiutaProfilo$()
      .pipe(
        tap(() => {
          this.snackBar.open('Profilo rifiutato', 'close', {
            panelClass: 'successSnack',
          });
          this.dialogRef.close(true);
        }),
        catchError((error) => {
          console.error('Errore rifiuto profilo:', error);
          this.snackBar.open('Errore durante il rifiuto del profilo', 'close', {
            panelClass: 'errorSnack',
          });
          return EMPTY;
        })
      )
      .subscribe();
  }

  closeDialog(refresh: boolean, rejectedCompetences: boolean = false): void {
    if (this.step === RifiutoStep.COMPETENZE && !rejectedCompetences) {
      this.snackBar.open(
        'Le competenze non rifiutate saranno disponibili nella funzionalità GESTIONE COMPETENZE',
        'close',
        { panelClass: 'successSnack' },
      );
    }
    this.dialogRef.close(refresh || this.step === RifiutoStep.COMPETENZE);
  }

  onNoClick(): void {
    if (this.step === RifiutoStep.PROFILO) {
      this.closeDialog(false);
    } else {
      this.rifiutaProfiloDiretto();
    }
  }
}
